import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-secondary-50 border-t border-background-200/70">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-10 md:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <span className="w-8 h-8 flex items-center justify-center">
                <i className="ri-book-open-fill text-2xl text-primary-500"></i>
              </span>
              <span className="font-heading text-xl font-bold text-foreground-900">
                韩漫网
              </span>
            </div>
            <p className="text-sm text-foreground-600 leading-relaxed">
              韩漫网——免费在线阅读无删减韩国漫画的平台。下拉式阅读模式，高清画质，每日更新，是您追漫的理想选择。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-foreground-900 mb-4">
              <a href="/category/all" className="hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap">热门分类</a>
            </h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/category/romance" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap">
                  恋爱漫画
                </Link>
              </li>
              <li>
                <Link to="/category/fantasy" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap">
                  奇幻漫画
                </Link>
              </li>
              <li>
                <Link to="/category/action" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap">
                  动作漫画
                </Link>
              </li>
              <li>
                <Link to="/category/thriller" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap">
                  悬疑漫画
                </Link>
              </li>
              <li>
                <Link to="/category/drama" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap">
                  剧情漫画
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-foreground-900 mb-4">
              <a href="/about" className="hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap">关于我们</a>
            </h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/about" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap">
                  品牌介绍
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap">
                  用户口碑
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap">
                  联系我们
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-foreground-900 mb-4">
              友情链接
            </h4>
            <ul className="space-y-2.5">
              <li>
                <a href="https://www.webtoons.com" target="_blank" rel="nofollow noopener noreferrer" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap">
                  Webtoon
                </a>
              </li>
              <li>
                <a href="https://www.kakaopage.com" target="_blank" rel="nofollow noopener noreferrer" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap">
                  KakaoPage
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-200/70 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; 2026 韩漫网 版权所有 · 韩漫网站免费在线阅读
          </p>
          <div className="flex items-center gap-4">
            <span className="text-xs text-foreground-500">关注我们</span>
            <a href="#" className="w-8 h-8 flex items-center justify-center text-foreground-500 hover:text-primary-600 transition-colors cursor-pointer" aria-label="微博">
              <i className="ri-weibo-line text-lg"></i>
            </a>
            <a href="#" className="w-8 h-8 flex items-center justify-center text-foreground-500 hover:text-primary-600 transition-colors cursor-pointer" aria-label="微信">
              <i className="ri-wechat-line text-lg"></i>
            </a>
            <a href="#" className="w-8 h-8 flex items-center justify-center text-foreground-500 hover:text-primary-600 transition-colors cursor-pointer" aria-label="B站">
              <i className="ri-bilibili-line text-lg"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}